import { Box, Container, Typography, useTheme } from '@mui/material';
import AdvantageBox from '../advantage-box/advantage-box.component';

import { ReactComponent as MessageIcon } from '../../assets/icons/chat.svg';
import { ReactComponent as MedicIcon } from '../../assets/icons/pill.svg';
import { ReactComponent as LuggageIcon } from '../../assets/icons/baggage.svg';
import { ReactComponent as ClockIcon } from '../../assets/icons/hour.svg';
import { ReactComponent as DrugStoreIcon } from '../../assets/icons/health.svg';
import { ReactComponent as HeadsetIcon } from '../../assets/icons/headset.svg';

import PhoneMobile from '../../assets/images/frame-mockup-iphone-mobile.webp';
import ParallaxPhoneWeb from '../parallax-phone/parallax-phone-web.component';

const AdvantagesGrid = () => {
  const advantages = [
    {
      id: 1,
      imageUrl: MessageIcon,
      title: 'Atendimento em português 24 horas por dia, todos os dias',
      text: 'A qualquer momento que precisar, você terá suporte da seguradora contratada, 24h por dia, 7 dias por semana, em português, durante toda a sua viagem.',
    },
    {
      id: 2,
      imageUrl: DrugStoreIcon,
      title: 'Despesas médicas e hospitalares',
      text: 'Em casos de acidente ou doenças contraídas durante a viagem, garanta atendimento médico, hospitalar ou odontológico.',
    },
    {
      id: 3,
      imageUrl: MedicIcon,
      title: 'Reembolso de despesas farmacêuticas',
      text: 'Em casos de medicamentos prescritos para o tratamento durante a viagem, receba o reembolso dos gastos.',
    },
    {
      id: 4,
      imageUrl: LuggageIcon,
      title: 'Atraso e Extravio de Bagagem',
      text: 'Em casos de atraso ou perda de bagagem, receba o reembolso das depesas.',
    },
    {
      id: 5,
      imageUrl: ClockIcon,
      title: 'Cancelamento e atraso de voos',
      text: 'Em casos de perda ou atraso de voos ou conexões, receba o reembolso das despesas.',
    },
    {
      id: 6,
      imageUrl: HeadsetIcon,
      title: 'Rede credenciada',
      text: 'Contamos com uma ampla rede credenciada para auxiliar o segurado, 24h, em qualquer lugar.',
    },
  ];

  const theme = useTheme();
  return (
    <Container
      maxWidth={'lg'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: `${theme.palette.grey[50]}`,
          borderRadius: `${theme.spacingValues.large}`,
          padding: `${theme.spacingValues.small} ${theme.spacingValues.medium}`,
          width: 'fit-content',
        }}
      >
        <Typography
          sx={{
            color: `${theme.palette.primary.main}`,
          }}
        >
          Benefícios
        </Typography>
      </Box>
      <Typography
        variant="h3"
        sx={{
          color: `${theme.palette.primary.contrastText}`,
          textAlign: { xs: 'center', md: 'inherit' },
          margin: { xs: '1rem 0', md: '1rem' },
        }}
      >
        Principais benefícios do{' '}
        <span style={{ color: theme.palette.primary.main }}>seguro viagem</span>
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' },
          gap: theme.spacingValues.medium,
          width: '100%',
        }}
      >
        {/* PRIMEIRA COLUNA */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateRows: 'repeat(3, 1fr)',
            gap: theme.spacingValues.medium,
            order: { xs: 2, md: 1 },
            height: '100%',
          }}
        >
          {advantages.slice(0, 3).map((advantage) => (
            <AdvantageBox
              key={advantage.id}
              advantage={advantage}
              sx={{
                height: '100%',
              }}
            />
          ))}
        </Box>

        {/* SEGUNDA COLUNA */}
        <Box
          sx={{
            height: '100%',
            order: { xs: 1, md: 2 }, // First on mobile, second on desktop
          }}
        >
          <ParallaxPhoneWeb sx={{ display: { xs: 'none', md: 'flex' } }} />
          <Box
            component="img"
            src={PhoneMobile}
            alt="Mobile phone mockup"
            sx={{
              display: { xs: 'block', md: 'none' },
              height: 'auto',
              width: '100%',
              maxHeight: '500px',
              margin: '0 auto',
              objectFit: 'contain',
              overflow: 'visible',
            }}
          />
        </Box>

        {/* TERCEIRA COLUNA */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            gap: theme.spacingValues.medium,
            order: { xs: 3, md: 3 },
          }}
        >
          {advantages.slice(3, 6).map((advantage) => (
            <AdvantageBox key={advantage.id} advantage={advantage} />
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default AdvantagesGrid;
